import { render } from "./App.vue?vue&type=template&id=1a418fa0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1a418fa0&lang=scss"

import exportComponent from "/home/runner/work/linker-frontend/linker-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__